export const SERVER_ADDRESS = "https://fanstandapp.com"
// export const SERVER_ADDRESS = "http://localhost:8080"
